import { Injectable } from '@angular/core';
import { HhsgSharedStuderFacility } from '../../models/sgportal-data-api-models/facility.model';
import { HhsgSharedStuderUnit } from '../../models/sgportal-data-api-models/unit.model';
import { HhsgSharedConfigService } from '../config.service';
import { HhsgSharedHttpService } from '../http.service';

@Injectable()
export class HhsgSharedStuderFacilityService {
	private readonly _controllerName: string = 'Facility';
    private readonly _sgPortalApiServer: string;

	constructor(private _configService: HhsgSharedConfigService, private _httpService: HhsgSharedHttpService) {
        this._sgPortalApiServer = _configService.appSettings.sgPortalApiServer;
    }

	public async getOrganizationFacilities(organizationId: number): Promise<HhsgSharedStuderFacility[]> {
		return this._httpService.doGetRequestAsync<HhsgSharedStuderFacility[]>(
            this._sgPortalApiServer, 
            this._controllerName, 
            `GetOrganizationFacilities/${organizationId}`);
	}

	public async getFacilityUnits(facilityId: number): Promise<HhsgSharedStuderUnit[]> {
		return this._httpService.doGetRequestAsync<HhsgSharedStuderUnit[]>(this._sgPortalApiServer, this._controllerName, `GetFacilityUnits/${facilityId}`);
	}

	public async getFacilitiesWithEmployeeCount(organizationId: number, showDeleted: boolean): Promise<HhsgSharedStuderFacility[]> {
		return this._httpService.doGetRequestAsync<HhsgSharedStuderFacility[]>(
            this._sgPortalApiServer, 
            this._controllerName, 
            `GetFacilitiesWithEmployeeCount/${organizationId}/${showDeleted}`);
	}
	
	public saveFacility(facility: HhsgSharedStuderFacility): Promise<string> {
		return this._httpService.doPostRequestAsync<any, string>(
            this._sgPortalApiServer, 
            this._controllerName, 
            'SaveFacility', 
            facility);
	}

	public updateFacility(facility: HhsgSharedStuderFacility): Promise<string> {
		return this._httpService.doPostRequestAsync<any, string>(this._sgPortalApiServer, this._controllerName, 'UpdateFacility', facility);
	}

	public updateIsDeletedStatus(facility: HhsgSharedStuderFacility): Promise<void> {
		return this._httpService.doPostRequestAsync(this._sgPortalApiServer, this._controllerName, 'UpdateDeleteStatus', facility);
	}
}
